const state = {
  itvdnStore:
    [
      {
        id: 1,
        title_en: "Java Developer",
        title_ua: "Java розробник",
        title_es: "Desarrollador Java",
        regnumber: "TP31617068D",
        grade: "1000 / 1000",
        examdate: "12.04.2021",
        image: "https://testprovider.com/ru/search-certificate/tp31617068d",
      },
      {
        id: 2,
        title_en: "HTML Coder",
        title_ua: "Верстальник сайтів",
        title_es: "Constructor del sitio",
        regnumber: "TP24303907D",
        grade: "1000 / 1000",
        examdate: "16.06.2021",
        image: "https://testprovider.com/ru/search-certificate/tp24303907d",
      },
      {
        id: 3,
        title_en: "JavaScript Developer",
        title_ua: "JavaScript розробник",
        title_es: "Desarrollador de JavaScript",
        regnumber: "TP84806711D",
        grade: "1000 / 1000",
        examdate: "01.07.2021",
        image: "https://testprovider.com/ru/search-certificate/tp84806711d",
      },
      {
        id: 4,
        title_en: "Angular Developer",
        title_ua: "Angular розробник",
        title_es: "Desarrollador Angular",
        regnumber: "TP31003654D",
        grade: "1000 / 1000",
        examdate: "02.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp31003654d",
      },
      {
        id: 5,
        title_en: "React Developer",
        title_ua: "React розробник",
        title_es: "Desarrollador React",
        regnumber: "TP37723782D",
        grade: "1000 / 1000",
        examdate: "09.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp37723782d",
      },
      {
        id: 6,
        title_en: "Frontend Developer",
        title_ua: "Фронтенд розробник",
        title_es: "Desarrollador Frontend",
        regnumber: "TP77692345D",
        grade: "1000 / 1000",
        examdate: "12.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp77692345d",
      },
      {
        id: 7,
        title_en: "PHP Developer",
        title_ua: "PHP розробник",
        title_es: "Desarrollador PHP",
        regnumber: "TP88892276D",
        grade: "1000 / 1000",
        examdate: "30.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp88892276d",
      },
      {
        id: 8,
        title_en: "Python Developer",
        title_ua: "Python розробник",
        title_es: "Desarrollador Python",
        regnumber: "TP45473683D",
        grade: "1000 / 1000",
        examdate: "16.11.2022",
        image: "https://testprovider.com/ru/search-certificate/tp45473683d",
      },
      {
        id: 9,
        title_en: "Ruby Developer",
        title_ua: "Ruby розробник",
        title_es: "Desarrollador Ruby",
        regnumber: "TP63925579D",
        grade: "1000 / 1000",
        examdate: "30.11.2022",
        image: "https://testprovider.com/ru/search-certificate/tp63925579d",
      }
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};